import { openRefinements } from './refinements';
import {
    ajaxCall_changeExternalRefinements,
    ajaxCall_clickSortOption,
    ajaxCall_changeGridView,
} from './ajaxCall';

export default initRefineBarComponent;

/**
 * javascript class for jQuery selector
 */
const CLASSELEM = {
    pageOverlay: '.js-plp-pageOverlay',
    refineBar: '.js-plp-refineBar',
    refineBar_buttonMenu: '.js-plp-refineBar-buttonMenu',
    refineBar_externalRefinements: '.js-plp-refineBar-menu-externalRefinements',
    refineBar_gridToggle: '.js-plp-refineBar-gridToggle',
    refineBar_menu: '.js-plp-refineBar-menu',
    refineBar_menuClose: '.js-plp-refineBar-closeMenu',
    refineBar_sortLink: '.js-plp-refineBar-menu-sortlink',
    refineBar_toggleRefinements: '.js-plp-refineBar-refinements',
};

/**
 * style class using in add or remove
 */
const STYLECLASS = {
    pageOverlay_open: 'cc-plp-pageOverlay_open',
    refineBar_button_open: 'cc-plp-refineBar-button_open',
    refineBar_menu_animation: 'cc-menuAnimation',
};

function initRefineBarComponent() {
    const $refineBar = $(CLASSELEM.refineBar);

    //add event
    $refineBar.on('click', CLASSELEM.refineBar_buttonMenu, openMenu);
    $refineBar.on('click', CLASSELEM.refineBar_sortLink, clickOnSortOption);
    $refineBar.on('click', CLASSELEM.refineBar_externalRefinements, changeExternalRefinement);
    $refineBar.on('click', CLASSELEM.refineBar_gridToggle, changeGridView);

    $(CLASSELEM.refineBar_toggleRefinements).on('click', openRefinements);
}

function openPageOverlay() {
    $(CLASSELEM.refineBar).append("<span class='js-plp-pageOverlay cc-plp-pageOverlay'></span>");
    const $overlay = $(CLASSELEM.pageOverlay);
    $overlay.show().addClass(STYLECLASS.pageOverlay_open);
}

function closePageOverlay() {
    const $overlay = $(CLASSELEM.pageOverlay);
    $overlay
        .removeClass(STYLECLASS.pageOverlay_open)
        .on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
            $overlay.hide().remove();
        });
}

function openMenu() {
    var $button = $(this);
    if ($button.hasClass(STYLECLASS.refineBar_button_open)) {
        return;
    }
    openPageOverlay();
    $button.addClass(STYLECLASS.refineBar_button_open);
    var $menu = $button.siblings(CLASSELEM.refineBar_menu);
    if (!$menu.length) {
        $menu = $button.find(CLASSELEM.refineBar_menu);
    }
    $menu.fadeIn(5).addClass(STYLECLASS.refineBar_menu_animation);

    $([CLASSELEM.pageOverlay, CLASSELEM.refineBar_menuClose].join(',')).on(
        'click',
        { button: $button, menu: $menu },
        closeMenu
    );
}

function closeMenu(e) {
    closePageOverlay();
    e.data.menu
        .removeClass(STYLECLASS.refineBar_menu_animation)
        .on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
            e.data.button.removeClass(STYLECLASS.refineBar_button_open);
            e.data.menu.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
            $(CLASSELEM.refineBar_menuClose).off('click');
        });
}

function clickOnSortOption(e) {
    e.preventDefault();
    e.stopPropagation();

    let url = $(this).attr('href');
    var $button = $(this).closest(CLASSELEM.refineBar_menu).siblings(CLASSELEM.refineBar_buttonMenu);
    var $menu = $(this).closest(CLASSELEM.refineBar_menu);

    ajaxCall_clickSortOption(url).then(function () {
        closeMenu({ data: { button: $button, menu: $menu } });
    });
}

function changeExternalRefinement() {
    var url = new URL(window.location.href);
    var searchParams = new URLSearchParams(url.search);
    var idExtRef = $(this).data('id');
    var prefNumTotal = 0;
    var prefNumExternalRef = 0;

    for (let [key, value] of searchParams.entries()) {
        if (key.includes('prefn')) {
            prefNumTotal = parseInt(key.match(/\d+/)[0]);
            if (value === idExtRef) {
                prefNumExternalRef = prefNumTotal;
            }
        }
    }

    var allElements = $(
        '.js-plp-refineBar-menu-body_externalRefinement .js-plp-refineBar-menu-externalInput'
    );

    var searchString = [];

    allElements.each(function () {
        let elem = $(this);
        if (elem.is(':checked')) {
            searchString.push(elem.data('valueid'));
        }
    });

    if (prefNumExternalRef === 0) {
        //NOT EXIST CASE
        if (searchString.length === 0) {
            return;
        } else {
            searchParams.append('prefn' + (prefNumTotal + 1), idExtRef);
            searchParams.append('prefv' + (prefNumTotal + 1), searchString.join('|'));
        }
    } else {
        //EXIST CASE
        if (searchString.length === 0) {
            for (let i = prefNumExternalRef; i < prefNumTotal + 1; i++) {
                if (i === prefNumTotal) {
                    searchParams.delete('prefn' + i);
                    searchParams.delete('prefv' + i);
                } else {
                    searchParams.set('prefn' + i, searchParams.get('prefn' + (i + 1)));
                    searchParams.set('prefv' + i, searchParams.get('prefv' + (i + 1)));
                }
            }
        } else {
            searchParams.set('prefn' + prefNumExternalRef, idExtRef);
            searchParams.set('prefv' + prefNumExternalRef, searchString.join('|'));
        }
    }

    url.search = searchParams.toString();
    var $button = $(this).closest(CLASSELEM.refineBar_menu).siblings(CLASSELEM.refineBar_buttonMenu);
    if (!$button.length) {
        $button = $(this).closest(CLASSELEM.refineBar_buttonMenu);
    }
    var $menu = $(this).closest(CLASSELEM.refineBar_menu);
    ajaxCall_changeExternalRefinements(url.toString()).then(function () {
        closeMenu({ data: { button: $button, menu: $menu } });
    });
}

function changeGridView() {
    let url = $(this).data('url');
    ajaxCall_changeGridView(url);
}

window.addEventListener('scroll', function (e) {
    const productsGrid = $('.js-plp-pagination');
    const $refineBar = $(CLASSELEM.refineBar);

    if (productsGrid.length > 0) {
        var productsGridFromTop = productsGrid.offset().top;
    }

    var refineBarFromTop = window.scrollY;

    if (productsGridFromTop < refineBarFromTop) {
        $refineBar.hide();
    } else {
        $refineBar.show();
    }
});

if($('.js-plp-refineBar').length) {
    $('.js-mainHeader-container').addClass('has-refinements');
    let lastScrollTopFilters = 0;
    $('.cc-mainHeader-container').css('position', 'sticky');
    $(window).on('scroll', function() {
        let st = $(this).scrollTop();
        const isFilterOpen = $('.js-plp-refineBar-refinements').hasClass('cc-plp-refineBar-button_open');
        const isLoginPopupOnTop = $('.js-mainHeader-login').hasClass('is-login-popup-on-top');

        if(!isFilterOpen) {
            if(document.documentElement.scrollTop || document.body.scrollTop > 0) {
                const sovraHeight = $('.cc-mainHeader-sovraheader').height();
                $('.js-mainHeader').css('top', `-${sovraHeight}px`);
                if(st < lastScrollTopFilters) {
                    $('.js-mainHeader').removeClass('z-bottom').addClass('z-top');
                    $('.js-plp-refineBar').removeClass('z-top').addClass('z-bottom');
                } else {
                    $('.js-mainHeader').removeClass('z-top').addClass('z-bottom');
                    if (!isLoginPopupOnTop) {
                        $('.js-plp-refineBar').removeClass('z-bottom').addClass('z-top');
                    } else {
                        $('.js-plp-refineBar').removeClass('z-top').addClass('z-bottom');
                    }
                }
            } else {
                $('.js-mainHeader').css('top', '0');
            }
        }
        lastScrollTopFilters = st;
    });
}

